import type { BidderV2 } from "mws-ts-v2-sdk";

import type { Guid } from "~/types/Misc";

export const hasGivenMarketingConsentToPartner = (
  partnerId: Guid | null,
  partnersMarketingConsent?: BidderV2["partnersMarketingConsent"],
) => {
  if (!partnerId) return false;

  if (!partnersMarketingConsent) return false;

  return partnersMarketingConsent.includes(partnerId);
};
